import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  searchSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: '5px',
  },
  search: {
    marginBottom: pxToRem(32),
  },
  resultsMessage: {
    marginBottom: pxToRem(8),
    fontWeight: 600,
  },
  noResultsSentence: {
    fontWeight: 400,
  },
  filter: {
    maxWidth: pxToRem(223),
    marginBottom: pxToRem(32),
    width: '100%',
  },
  scrollablePane: {
    width: 'fit-content',
    '& [role=grid]': {
      maxHeight: pxToRem(700),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
    },
    '& .ms-DetailsList-headerWrapper': {
      flex: '0 0 auto',
    },
    '& .ms-DetailsList-contentWrapper': {
      flex: '1 1 auto',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
  },
});
